export default __webpack_public_path__ + "static/media/shroom.902bf893.png";